import {formatDateLocalized} from '@sollapay/utils';

import type {BeneficiaryRow} from './types/beneficiary-draft.types';
import type {PartyRole} from '@sollapay/enums';
import type {ExportColumn} from '@sollapay/web-core';
import type {TFunction} from 'i18next';

export function createBeneficiaryExportColumns(
  t: TFunction,
  language: string,
  addableRoles: PartyRole[]
): ExportColumn<BeneficiaryRow>[] {
  const isManualRole = (role: string) => addableRoles.includes(role as PartyRole);

  return [
    {
      header: t('view.beneficiaries.columns.name'),
      value: row => row.name
    },
    {
      header: t('view.beneficiaries.columns.role'),
      value: row => t(`partyRole.${row.role}`)
    },
    {
      header: t('view.beneficiaries.columns.idNumber'),
      value: row => row.idNumber
    },
    {
      header: t('view.beneficiaries.columns.date'),
      value: row => (row.date ? formatDateLocalized(row.date, language) : '')
    },
    {
      header: t('view.beneficiaries.columns.address'),
      value: row => row.address
    },
    {
      header: t('view.beneficiaries.columns.source'),
      value: row =>
        t(
          isManualRole(row.role)
            ? 'view.beneficiaries.source.manual'
            : 'view.beneficiaries.source.deal'
        )
    }
  ];
}
